import {SetAttributes} from './Edit';
import {Type} from '@wordpress/api/types';
import {CheckboxControl, PanelBody} from '@wordpress/components';
import {__, sprintf} from '@wordpress/i18n';


export type CurrentFamilyOptions = {
	parent_only: boolean;
	'parent_only/display-sibling/child-page': boolean;
	'parent_only/display-sibling/no-grandchildren': boolean;
}

type Props = {
	attributes: CurrentFamilyOptions;
	setAttributes: SetAttributes;
	type?: Type<'edit'>;
};

const CurrentFamily = ( {attributes, setAttributes, type}: Props ) => {
	return (
		<PanelBody
			title={__( 'Current Family Only', 'advanced-sidebar-menu' )}
			initialOpen={attributes.parent_only}
		>
			<CheckboxControl
				/* translators: Selected post type single label */
				label={sprintf( __( 'Display the current %s\'s direct family only', 'advanced-sidebar-menu' ), type?.labels?.name.toLowerCase() ?? '' )}
				/* translators: Selected post type single label */
				help={sprintf( __( 'Only display the current %1$s and any parents, grandparents, children or grandchildren of the current %1$s.', 'advanced-sidebar-menu' ), type?.labels?.name.toLowerCase() ?? '' )}
				checked={attributes.parent_only}
				onChange={value => {
					setAttributes( {
						parent_only: value,
					} );
				}}
			/>
			{attributes.parent_only && <>
				<CheckboxControl
					/* translators: post type single label */
					label={sprintf( __( 'Display siblings of the current %s', 'advanced-sidebar-menu' ), type?.labels?.singular_name.toLowerCase() ?? '' )}
					/* translators: post type single label */
					help={sprintf( __( 'Display siblings of the current %1$s when on a child or grandchild %1$s.', 'advanced-sidebar-menu' ), type?.labels?.singular_name.toLowerCase() ?? '' )}
					checked={attributes[ 'parent_only/display-sibling/child-page' ]}
					onChange={value => {
						setAttributes( {
							'parent_only/display-sibling/child-page': value,
						} );
					}}
				/>
				{! attributes[ 'parent_only/display-sibling/child-page' ] &&
					<CheckboxControl
						label={__( 'Display siblings when there are no children', 'advanced-sidebar-menu' )}
						/* translators: Selected post type single label */
						help={sprintf( __( 'Display siblings of the current %1$s when the current %1$s has no children.', 'advanced-sidebar-menu' ), type?.labels?.singular_name.toLowerCase() ?? '' )}
						checked={attributes[ 'parent_only/display-sibling/no-grandchildren' ]}
						onChange={value => {
							setAttributes( {
								'parent_only/display-sibling/no-grandchildren': value,
							} );
						}}
					/>}
			</>}
		</PanelBody>
	);
};

export default CurrentFamily;
